import type { ColorPalette } from './types'

/**
 * safeapp olive-green light palette.
 *
 * Drop-in replacement for packages/theme/src/palettes/light.ts in
 * safe-global/safe-wallet-monorepo. Same shape (ColorPalette), same roles:
 * `primary` is the ink color in light mode, `secondary` is the brand color.
 *
 * Only brand / neutral / surface values changed; semantic status colors
 * (error, error1, success, info, warning, warning1, review) are verbatim
 * upstream. Hex values mirror theme/tokens.json in chews/safeapp — keep in
 * sync (see theme/safe-ui-overlay/README.md).
 */
const lightPalette: ColorPalette = {
  text: {
    primary: '#1A1D14',
    secondary: '#9A9E90',
    disabled: '#DDDFD6',
    contrast: '#FFFFFF',
  },
  primary: {
    dark: '#3D4234',
    main: '#1A1D14',
    light: '#63665C',
  },
  secondary: {
    dark: '#49521F',
    main: '#5F6B2E',
    light: '#CBD79A',
    background: '#F3F6E7',
  },
  border: {
    main: '#A3A69B',
    light: '#DDDFD6',
    background: '#F4F5F1',
  },
  error: {
    dark: '#8A1C27',
    main: '#FF5F72',
    light: '#F79BA7',
    background: '#FFE0E6',
  },
  error1: {
    main: '#FFE0E6',
    contrastText: '#8A1C27',
  },
  success: {
    dark: '#1C5538',
    main: '#00B460',
    light: '#84D9A0',
    background: '#CBF2DB',
  },
  info: {
    dark: '#15566A',
    main: '#00BFE5',
    light: '#78D2E7',
    background: '#CEF0FD',
  },
  warning: {
    dark: '#6C2D19',
    main: '#FF8C00',
    light: '#F9B37C',
    background: '#FFECC2',
  },
  warning1: {
    main: '#FFECC2',
    text: '#6C2D19',
    contrastText: '#FF8C00',
  },
  review: {
    main: '#D6A100',
    background: '#FFF8CC',
  },
  background: {
    default: '#FFFFFF',
    main: '#F4F5F1',
    sheet: '#F4F5F1',
    paper: '#FFFFFF',
    light: '#F3F6E7',
    secondary: '#DDDFD6',
    skeleton: 'rgba(0, 0, 0, 0.04)',
    disabled: '#7878801F',
  },
  backdrop: {
    main: '#63665C',
  },
  logo: {
    main: '#1A1D14',
    background: '#EEEFEA',
  },
  static: {
    main: '#1A1D14',
    light: '#63665C',
    primary: '#FFFFFF',
    textSecondary: '#9A9E90',
    textBrand: '#98A65A',
  },
}

export default lightPalette
